<app-breadcrumbs *ngIf="hasBreadcrumbs"></app-breadcrumbs>
<h3 *ngIf="!hasBreadcrumbs && title" class="title {{titleClasses}}">{{title}}</h3>
<div class="add-on {{addonClasses}}">
    <ng-content></ng-content>
    <app-responsive-dropdown #responsiveDropdown class="d-none"></app-responsive-dropdown>
</div>
